@let menus = contextMenuService.menus.$ | async;

@for (contextMenu of menus; track contextMenu.options.id) {
    <bazis-context-menu [contextMenu]="contextMenu"></bazis-context-menu>
}
